import {create} from 'zustand';
import axios from 'axios';

export const useDeliveryStore = create((set, get) => ({
    // Модалка Информация о доставке в детальной карточке продукта, на странице доставка и оплата
    deliveryInformationFlag: false,
    // Статус получения информации о сроках доставки
    deliveryInformationStatus: true,
    deliveryData: {
        title: '',
        data: []
    },
    // Отправляемые данные для получения информации о сроках доставки
    requestDeliveryData: {
        deliveryType: '', // 'brandShop', 'pvz'
        fieldType: 'city', // 'city', 'region'
        productData: [
            // {
            //     productId: null,
            //     productDataId: null,
            // }
        ]
    },

    setRequestDeliveryData: (deliveryType, productData = [], fieldType = 'city') => {
        set({
            requestDeliveryData: {
                deliveryType,
                fieldType,
                productData,
            }
        });
    },

    getDeliveryInformation: async () => {
        try {
            const {requestDeliveryData} = get();

            const response = await axios.post('/delivery-info', requestDeliveryData);
            const {data} = response;
            const {success = {}} = data;
            const {deliveryData = {}} = success;

            set({deliveryData});

        } catch (error) {
            console.log('error', error);
        }
    },

    /**
     * Открытие модалки "информация о доставке"
     * @param deliveryType
     * @param productData
     * @param fieldType
     * @returns {Promise<void>}
     */
    openModalDeliveryInformation: async (deliveryType, productData = [], fieldType = 'city') => {
        // записываем данные
        get().setRequestDeliveryData(deliveryType, productData, fieldType);

        // запрашиваем данные
        await get().getDeliveryInformation();

        // открываем модалку
        set({deliveryInformationFlag: true});

        // обновляем статус
        set({deliveryInformationStatus: false});
    },

    /**
     * Закрытие модалки "информация о доставке"
     */
    closeModalDeliveryInformation: () => {
        set({
            deliveryInformationFlag: false,
            deliveryInformationStatus: true,
        });
    },
}));
